export const SET_LOADING_DATA = '@user/SET_LOADING_DATA';
export const SET_LOADING_SEND = '@user/SET_LOADING_SEND';

export const GET_ALL_REQUEST = '@user/GET_ALL_REQUEST';
export const GET_ALL_SUCCESS = '@user/GET_ALL_SUCCESS';

export const GET_BY_ID_REQUEST = '@user/GET_BY_ID_REQUEST';
export const GET_BY_ID_SUCCESS = '@user/GET_BY_ID_SUCCESS';

export const SAVE_REQUEST = '@user/SAVE_REQUEST';
export const SAVE_SUCCESS = '@user/SAVE_SUCCESS';

export const DELETE_ITEM = '@user/DELETE_ITEM';
export const EDIT_ITEM = '@user/EDIT_ITEM';

export const DELETE_DEVICE_REQUEST = '@user/DELETE_DEVICE_REQUEST';
export const DELETE_DEVICE_SUCCESS = '@user/DELETE_DEVICE_SUCCESS';

export const UPDATE_DEVICE_REQUEST = '@user/UPDATE_DEVICE_REQUEST';
export const UPDATE_DEVICE_SUCCESS = '@user/UPDATE_DEVICE_SUCCESS';

export const SEARCH = '@user/SEARCH';

export const SET_PAGE = '@user/SET_PAGE';
export const SET_ROWS_PER_PAGE = '@user/SET_ROWS_PER_PAGE';
export const SET_ORDER = '@user/SET_ORDER';
export const SET_ORDERBY = '@user/SET_ORDEBY';
